import { Wrench, Scissors, GraduationCap, Heart } from 'lucide-react';
import { ServiceCard } from './ServiceCard';
import { FormattedMessage } from 'react-intl';

const categories = [
  { icon: Wrench, id: '6' },
  { icon: Scissors, id: '4' },
  { icon: GraduationCap, id: '8' },
  { icon: Heart, id: '15' },
];

export function Categories() {
  return (
    <section className='py-20 bg-gray-50'>
      <div className='container mx-auto px-6'>
        <h2 className='text-3xl font-bold text-center mb-12'>
          <FormattedMessage
            id='categories.title'
            defaultMessage='Популярные категории услуг'
          />
        </h2>
        <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8'>
          {categories.map((category) => (
            <ServiceCard key={category.id} {...category} />
          ))}
        </div>
      </div>
    </section>
  );
}
